import {
  Button,
  Card,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useImperativeHandle, useEffect, useState, useRef } from "react";
import { logoFullWhite, logoIconWhite } from "assets/images/logo/";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import dayjs from "dayjs";
import {
  doiTuongOptions,
  gioiTinhOptions,
} from "assets/constants/select-catagory-options";
import { normalizePhoneNumber } from "helper/common";
import Icons from "assets/icons";
import { medicalExaminationService } from "api";
import { HeaderPrintForm } from "components/common";
import ReactToPrint from "react-to-print";

const InformModal = React.forwardRef((props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<any>(null);

  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setData: setData,
  }));
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onSave = async () => {
    // await props.onSave(data)
    closeModal();
  };

  useEffect(() => {}, [data]);
  useEffect(() => {}, [isModalOpen]);
  return (
    <Row className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        title="Thông báo"
      >
        <div>
          <Row align={"middle"} justify={"center"}>
            <Typography.Text>
              Mã lỗi:{" "}
              <Typography.Text type="danger">{`${data?.maLoi ?? ""}, ${
                data?.thongBao
              }`}</Typography.Text>
              !&nbsp; Mã thẻ:{" "}
              <Typography.Text style={{ color: "#0085FF" }}>{`${
                data?.maThe ?? ""
              }`}</Typography.Text>
              ,&nbsp; Họ tên:{" "}
              <Typography.Text style={{ color: "#0085FF" }}>{`${
                data?.hoTen ?? ""
              }`}</Typography.Text>
              ,&nbsp;
              {`Ngày sinh: ${data?.ngaySinh ?? ""}`}&nbsp;
              {/* {`Giới tính: ${gioiTinhOptions.find(it => it.value === data?.gioiTinh)?.label || ""}!`}&nbsp; */}
              {`(ĐC: ${data?.diaChi});`}&nbsp; Nơi KCBBĐ:{" "}
              <Typography.Text style={{ color: "#0085FF" }}>{`${
                data?.maNoiDKKCB ?? ""
              } - ${data?.noiDKKCB ?? ""}`}</Typography.Text>
              ;&nbsp; Hạn thẻ:{" "}
              <Typography.Text style={{ color: "#0085FF" }}>{`${
                data?.gioiHanTheTu ?? ""
              } - ${data?.gioiHanTheDen ?? ""}`}</Typography.Text>
              {`)`}
            </Typography.Text>
          </Row>
          <Row style={{ marginTop: "8px" }}>
            <Row justify={"center"} style={{ gap: "4px" }}>
              <Button type="primary" danger onClick={closeModal}>
                ĐÓNG
              </Button>
            </Row>
          </Row>
        </div>
      </Modal>
    </Row>
  );
});
export default InformModal;
